export default __webpack_public_path__ + "static/media/IMG_8842 copie.987d8379.jpg";